import styled from 'styled-components'
import {Link} from 'react-router-dom'
import miniIcon from '../../assets/images/16@2x.webp'

export const FocusBoxWrap = styled.div`
    width: 440px;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        width: 504px;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }
`
export const FocusImageLink = styled(Link)`
    text-decoration: none;
    display: block;
    @media screen and (max-width: 767px) {
        margin: 0 -12px;
    }
`

export const FocusImage = styled.img`
    width: 100%;
    height: 275px;
    object-fit: cover;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        height: 315px;
    }

    @media screen and (max-width: 767px) {
        height: 258px;
    }

    @media screen and (max-width: 374px) {
        height: 200px;
    }
`

export const FocusTitle = styled(Link)`
    margin: 5px 0 3px;
    position: relative;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    text-decoration: none;
    color: #222;
    font-size: 18px;
    font-weight: bold;
    line-height: 21px;

    @media screen and (max-width: 767px) {
        font-size: 20px;
        line-height: 25px;
    }
`

export const FocusDesc = styled.p`
    color: #222;
    font-size: 12px;
    line-height: 14px;
    width: 425px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media screen and (max-width: 767px) {
        width: 100%;
        font-size: 14px;
        color: #222;
        opacity: .8;
        line-height: 18px;
        -webkit-line-clamp: 4;

    }
`



export const NewsNewBox = styled.div`
    flex: 1;
`

export const SrollPane = styled.ul`
    list-style: none;
    overflow: visible;
    overflow-y: auto;
    
    width: 100%;
    height: 351px;
    padding: 0 10px;

    &::-webkit-scrollbar {
        width: 3px;
    }

    &::-webkit-scrollbar-track {
        background: #F5F5F5;
    }


    &::-webkit-scrollbar-thumb {
        background: #D3D3D3;
    }

    @media screen and (max-width: 768px) {
        height: 395px;
    }
`
export const NewsNewItem = styled.li`
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
    position: relative;

    &:before {
        position: absolute;
        width: 4px;
        height: 4px;
        border-radius: 3px;
        background-color: #333e56;
        left: 0;
        top: 6px;
        content: '';
    }
`

export const NewsNewTitleName = styled.h2`
    display: flex;
    justify-content: space-between;
`
export const NewsNewLink = styled(Link)`
    text-decoration: none;
    color: #222;
    font-size: 13px;
    line-height: 17px;
    
    margin-left: 10px;
    font-weight: 400;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media screen and (max-width: 768px) {
        font-weight: 500;
    }
`
export const CommentTotal = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
`

export const CommentLabel = styled.span`
    color: #d12728;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
`

export const CommentIcon = styled.i`
    background-image: url(${miniIcon});
    display: block;
    background-repeat: no-repeat;
    background-size: 16px auto;
    background-position: -2px -82px;
    width: 12px;
    height: 12px;
    content: '';
`
export const FlexLayout = styled.div`
    display: flex;
`

export const ListNewsFocus = styled.ul`
    list-style: none;
    display: flex;
    margin-top: 12px;
`

export const NewsFocusItem = styled.li`
    @media screen and (max-width: 767px) {
        display: flex;
        border-bottom: 1px dotted #d8d8d8;
        padding: 8px 0;
    }
`

export const NewsFocusImageLink = styled(Link)`
    text-decoration: none;
    display: block;
`

export const NewsFocusImage = styled.img`
    width: 100%;
    height: 96px;

    @media screen and (max-width: 767px) {
        width: 166px;
        height: 103px;
    }

    @media screen and (max-width: 374px) {
        width: 128px;
        height: 80px;
    }
`

export const NewsFocusTitle = styled(Link)`
    text-decoration: none;
    margin-top: 6px;
    color: #222;
    font-size: 13px;
    font-weight: 500;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    align-self: flex-start;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        font-weight: 700;
    }

    @media screen and (max-width: 767px) {
        font-size: 18px;
        font-weight: 700;
        margin-left: 10px;
    }

    @media screen and (max-width: 374px) {
        margin-top: 0;
        font-size: 16px;
    }
`


export const BoxHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`